<template>
  <div class="d-flex flex-row items boardwork-title">
    <span class="title primary mgn-Rs"></span>
    <span class="block-title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'BlockTitle',
  props: ['title']
};
</script>
<style scoped>
.title {
  height: 15px;
  width: 15px;
  font-size: 20px;
}
.items {
  align-items: center;
}
.boardwork-title {
  padding: 12px 0px;
}
.block-title {
  color: #bb161b;
  font-size: 20px;
}
</style>
